import { render, staticRenderFns } from "./EditAreaPm.vue?vue&type=template&id=6b741b26&scoped=true&"
import script from "./EditAreaPm.vue?vue&type=script&lang=js&"
export * from "./EditAreaPm.vue?vue&type=script&lang=js&"
import style0 from "./EditAreaPm.vue?vue&type=style&index=0&id=6b741b26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b741b26",
  null
  
)

export default component.exports